import React from 'react';

const Lightning = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="43" viewBox="0 0 28 43" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.864 14.5951H18.0296L27.2522 3.67568C27.7217 3.11643 27.8332 2.35133 27.5334 1.67859C27.2344 1.00668 26.581 0.599976 25.8636 0.599976H12.8259C12.1367 0.599976 11.5054 0.995333 11.1913 1.62372L0.303146 23.3689C0.0105411 23.9554 0.0354479 24.7217 0.369666 25.2842C0.701049 25.8467 1.29547 26.2567 1.93819 26.2567H9.9411L5.82083 40.2145C5.5669 41.0845 5.95053 41.9878 6.73601 42.4047C7.00411 42.5483 7.29206 42.6 7.5796 42.6C8.1313 42.6 8.67034 42.3376 9.02947 41.8654L27.3127 17.7514C27.7438 17.1812 27.8217 16.3555 27.5132 15.7076C27.2047 15.0576 26.5656 14.5947 25.8628 14.5947L25.864 14.5951Z"
        fill="white"
      />
    </svg>
  );
};

export default Lightning;
